export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_VACCINE":
      return [...state, action.payload.vaccine];
    case "UPDATE_VACCINES":
      return action.payload.vaccines || [];
    case "DELETE_VACCINE":
      return state.filter((vaccine) => {
        return vaccine.id !== action.payload.vaccine.id
      });
    default:
      return state;
  }
}
